export const PASSWORD_POLICY_TYPE = {
    PASSWORD_POLICY_VALIDITY_PERIOD: "passportPolicyValidityPeriod",
    PASSWORD_POLICY_MIN_LENGTH: "passportPolicyMinLength",
    PASSWORD_POLICY_INACTIVITY_PERIOD: "passportPolicyInactivityPeriod",
    PASSWORD_POLICY_DIFFERENT_LETTER_CASES: "passportPolicyDifferentLetterCases",
    PASSWORD_POLICY_SPECIAL_CHARACTERS: "passportPolicySpecialCharacters",
    PASSWORD_POLICY_DIGITS: "passportPolicyDigits",
    PASSWORD_POLICY_MAX_INVALID_ATTEMPTS: "passportPolicyMaxInvalidAttempts",
    PASSWORD_POLICY_USER_LOCK_TIME: "passportPolicyUserLockTime"
};
